/**
 * FormField Component
 *
 * Reusable form field wrapper with label, input, and error display
 *
 * Epic: Super Admin Catalog Management Console
 * Story: SCRUM-300
 */

export default function FormField({
  label,
  name,
  type = 'text',
  value,
  onChange,
  error,
  required = false,
  helperText,
  placeholder,
  rows,
  options, // For select inputs
  min,
  max,
  step,
  disabled = false
}) {
  const inputClasses = `block w-full px-3 py-2 border ${
    error ? 'border-red-300' : 'border-gray-300'
  } rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors ${
    disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'
  }`;

  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>

      {type === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          rows={rows || 4}
          placeholder={placeholder}
          disabled={disabled}
          className={inputClasses}
        />
      ) : type === 'select' ? (
        <select
          id={name}
          name={name}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className={inputClasses}
        >
          {options?.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          className={inputClasses}
        />
      )}

      {helperText && !error && (
        <p className="mt-1 text-sm text-gray-500">{helperText}</p>
      )}

      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
